import { PageShell, PageHero } from "../components/PageShell";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { Marquee } from "../components/Marquee";
import { CtaBanner } from "../components/CtaBanner";
import { marqueeItems } from "../data/content";

const philosophy = ["Understand deeply.", "Build thoughtfully.", "Deliver reliably.", "Improve continuously."];

export default function About() {
  return (
    <PageShell>
      <div data-testid="about-page">
        <PageHero
          overline="About"
          title="We Build With Experience. We Move With Purpose."
          description={
            <>
              <p>
                Spark Link IT Solutions was created with a simple belief:
                <strong> technology should make businesses better.</strong>
              </p>
              <br/>
              <p>
                We help businesses turn ideas, challenges, and opportunities into
                reliable digital solutions across custom software, web and mobile
                applications, automation, AI, cloud, and legacy modernization.
              </p>
            </>
          }
        />

        <section className="py-20 lg:py-28">
          <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
            <div className="lg:col-span-8">
              <SectionHeading overline="Our story" title="Technology That Creates Practical Value." />
              <Reveal delay={0.2}>
                <div className="card-gradient mt-8 rounded-2xl border border-white/10 p-8 lg:p-10">
                  <p className="text-base sm:text-lg leading-8 text-slate-300">
                    Spark Link IT Solutions helps businesses turn challenges into clear, practical technology outcomes.
                  </p>
                  <p className="mt-4 text-base leading-8 text-slate-400">
                    We work across custom software, enterprise applications, automation, cloud, AI integration, and legacy modernization to create systems that are easier to use, easier to maintain, and ready to grow with your business.
                  </p>
                  <p className="mt-4 text-base leading-8 text-slate-400">
                    Whether you need a new product built from the ground up or a reliable partner to modernize and support what already exists, we focus on thoughtful delivery and long-term value.
                  </p>
                </div>
              </Reveal>
            </div>

            {/* <div className="lg:col-span-5">
              <Reveal delay={0.25} className="h-full">
                <div className="card-gradient relative h-full overflow-hidden rounded-2xl border border-white/10 p-8 lg:p-10" data-testid="founder-card">
                  <div className="bg-grid pointer-events-none absolute inset-0 opacity-40" />
                  <div
                    className="pointer-events-none absolute -right-20 -top-20 h-56 w-56 rounded-full blur-3xl"
                    style={{ background: "radial-gradient(closest-side, rgba(0,102,255,0.3), transparent)" }}
                  />
                  <div className="relative">
                    <div className="flex items-center gap-5">
                      <span className="spark-gradient grid h-16 w-16 place-items-center rounded-2xl font-display text-xl font-bold text-white shadow-[0_0_32px_rgba(0,102,255,0.4)]">
                        AB
                      </span>
                      <div>
                        <p className="font-display text-xl font-semibold text-white">Amit Bishnoi</p>
                        <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-cyan-400">
                          Founder & Technology Lead
                        </p>
                      </div>
                    </div>
                    <p className="mt-6 text-sm leading-relaxed text-slate-400">
                      A Senior Full-Stack .NET Developer with 5+ years of professional experience
                      building enterprise applications using ASP.NET Core, Angular, and SQL Server.
                    </p>
                    <p className="mt-4 text-sm leading-relaxed text-slate-400">
                      An engineer focused on solving complex business problems through thoughtful
                      architecture, modern software engineering, automation, and practical use of
                      emerging technologies — leading Spark Link with a focus on solutions that are
                      reliable, scalable, and designed for long-term value.
                    </p>
                    <div className="mt-7 flex flex-wrap gap-2 border-t border-white/[0.07] pt-6">
                      {["ASP.NET Core", "Angular", "SQL Server", "Azure", "AI Integration"].map((t) => (
                        <span key={t} className="chip">{t}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </Reveal>
            </div> */}
          </div>
        </section>

        <Marquee items={marqueeItems} />

        <section className="py-20 lg:py-32" data-testid="philosophy-section">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeading overline="Our philosophy" title="How We Think About the Work." />
            <div className="mt-14">
              {philosophy.map((line, i) => (
                <Reveal key={line} delay={0.08 * i}>
                  <div
                    className="group flex items-baseline gap-6 border-b border-white/[0.07] py-7 lg:gap-12 lg:py-9"
                    data-testid={`philosophy-line-${i}`}
                  >
                    <span className="font-mono text-xs tracking-[0.25em] text-cyan-400/80">
                      0{i + 1}
                    </span>
                    <p className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-500 transition-colors duration-500 group-hover:text-white">
                      {line}
                    </p>
                    <span className="ml-auto hidden h-px flex-1 max-w-40 bg-gradient-to-r from-white/15 to-transparent sm:block" />
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        <CtaBanner
          title="Work With a Founder-Led Team."
          text="Every engagement gets direct attention from senior engineering — not layers of handoffs."
        />
      </div>
    </PageShell>
  );
}
